<script setup>
import {computed} from 'vue'
import {useRouter} from 'vue-router'

import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const router = useRouter()
const pageEditorStore = usePageEditorStore()

const activePageContentId = computed(() => pageEditorStore.activePageContentId)
const activeContent = computed(() => pageEditorStore.contentItems?.find(o => o.pageContentId === activePageContentId.value))
const contentAreaName = computed(() => pageEditorStore.activeContentAreaName || activeContent.value?.contentAreaName)
const contentArea = computed(() => pageEditorStore.contentAreas?.find(o => o.name === contentAreaName.value))

const onMouseover = () => {
    pageEditorStore.hoverContentAreaName = contentAreaName.value
}

const onMouseout = () => {
    pageEditorStore.hoverContentAreaName = ''
}

const selectContentArea = async () => {
    await pageEditorStore.goToContentArea({
        router,
        contentAreaName: contentAreaName.value
    })

    pageEditorStore.leftSidebarActiveTab = 'Content'

    pageEditorStore.scrollToContentArea({
        contentAreaName: contentAreaName.value
    })
}
</script>

<template>
    <div v-if="contentArea" class="d-inline">
        <i class="bi-chevron-compact-right mx-1 align-middle"/>

        <Button @mouseover="onMouseover" @mouseout="onMouseout" @click="selectContentArea"
                class="btn-sm lh-1 p-1">
            <small>{{ contentArea.label }}</small>
        </Button>
    </div>
</template>